import { NotaPratica, AggiornamentoPratica, RichiestaPraticaStatusBE } from './pratica-utente.model';

export interface AnagraficaDettaglio {
  id?: string;
  slugComune?: string;
  nome?: string;
  cognome?: string;
  cittaNascita?: string;
  provinciaNascita?: string;
  nazioneNascita?: string;
  dataNascita?: string;
  cittaResidenza?: string;
  indirizzo?: string;
  cittadinanza?: string;
  codiceFiscale?: string;
  tipoDocumento?: string;
  numeroDocumento?: string;
  scadenzaDocumento?: string;
  documentoAnagrafica1?: string;
  documentoAnagrafica2?: string;
  documentoAnagrafica3?: string;
  documentoAnagrafica4?: string;
  documentoAnagrafica5?: string;
  telefonoFisso?: string;
  cellulare?: string;
  email?: string;
  statoAnagrafica?: string;
  messaggioVerifica?: string;
  boolean1_1?: boolean;
  boolean1_2?: boolean;
  boolean1_3?: boolean;
  boolean1_4?: boolean;
  boolean1_5?: boolean;
  text1_1?: string;
  text1_2?: string;
  text1_3?: string;
  text1_4?: string;
  text1_5?: string;
  boolean2_1?: boolean;
  boolean2_2?: boolean;
  boolean2_3?: boolean;
  boolean2_4?: boolean;
  boolean2_5?: boolean;
  text2_1?: string;
  text2_2?: string;
  text2_3?: string;
  text2_4?: string;
  text2_5?: string;
  created_at?: string;
  updated_at?: string;
}

export interface ElementoNucleoFamiliareDettaglio {
  id?: string;
  slugComune?: string;
  nome?: string;
  cognome?: string;
  dataNascita?: string;
  cittaNascita?: string;
  provinciaNascita?: string;
  nazioneNascita?: string;
  cittadinanza?: string;
  codiceFiscale?: string;
  parentela?: string;
  nonAutosufficiente?: boolean;
  percepisceReddito?: boolean;
  tipologieRedditoPercepito?: string[];
  importo?: number;
  abilitato?: boolean;
  int1_1?: number;
  int1_2?: number;
  int1_3?: number;
  int1_4?: number;
  int1_5?: number;
  text1_1?: string;
  text1_2?: string;
  text1_3?: string;
  text1_4?: string;
  text1_5?: string;
  text1_6?: string;
  text1_7?: string;
  boolean1_1?: boolean;
  boolean1_2?: boolean;
  boolean1_3?: boolean;
  boolean1_4?: boolean;
  boolean1_5?: boolean;
  double1_1?: number;
  double1_2?: number;
  double1_3?: number;
  double1_4?: number;
  double1_5?: number;
  boolean2_1?: boolean;
  boolean2_2?: boolean;
  boolean2_3?: boolean;
  boolean2_4?: boolean;
  boolean2_5?: boolean;
  text2_1?: string;
  text2_2?: string;
  text2_3?: string;
  text2_4?: string;
  text2_5?: string;
  created_at?: string;
  updated_at?: string;
}

export interface PraticaDettaglio {
  slugComune?: string;
  codicePratica?: string;
  counter?: number;
  codiceTipoPratica?: string;
  anagrafica?: AnagraficaDettaglio;
  elementiNucleoFamiliare?: ElementoNucleoFamiliareDettaglio[];
  documento1?: string;
  documento2?: string;
  documento3?: string;
  documento4?: string;
  documento5?: string;
  documento6?: string;
  documento7?: string;
  documento8?: string;
  documento9?: string;
  documento10?: string;
  documentoOperatore1?: string;
  labelDocumentoOperatore1?: string;
  documentoOperatore2?: string;
  labelDocumentoOperatore2?: string;
  documentoOperatore3?: string;
  labelDocumentoOperatore3?: string;
  documentoOperatore4?: string;
  labelDocumentoOperatore4?: string;
  documentoOperatore5?: string;
  labelDocumentoOperatore5?: string;
  nomeFileScreenPratica?: string;
  nomeFilePdfPraticaOriginale?: string;
  boolean1_1?: boolean;
  boolean1_2?: boolean;
  boolean1_3?: boolean;
  boolean1_4?: boolean;
  boolean1_5?: boolean;
  boolean1_6?: boolean;
  boolean1_7?: boolean;
  boolean1_note?: string;
  boolean2_1?: boolean;
  boolean2_2?: boolean;
  boolean2_3?: boolean;
  boolean2_4?: boolean;
  boolean2_5?: boolean;
  boolean2_6?: boolean;
  boolean2_7?: boolean;
  boolean2_note?: string;
  boolean3_1?: boolean;
  boolean3_2?: boolean;
  boolean3_3?: boolean;
  boolean3_4?: boolean;
  boolean3_5?: boolean;
  boolean3_6?: boolean;
  boolean3_7?: boolean;
  boolean3_note?: string;
  text1_1?: string;
  text1_2?: string;
  text1_3?: string;
  text1_4?: string;
  text1_5?: string;
  text1_6?: string;
  text1_7?: string;
  text1_8?: string;
  text2_1?: string;
  text2_2?: string;
  text2_3?: string;
  text2_4?: string;
  text2_5?: string;
  text2_6?: string;
  text2_7?: string;
  text2_8?: string;
  int1_1?: number;
  int1_2?: number;
  int1_3?: number;
  int1_4?: number;
  int1_5?: number;
  int1_6?: number;
  int1_7?: number;
  int1_8?: number;
  int2_1?: number;
  int2_2?: number;
  int2_3?: number;
  int2_4?: number;
  int2_5?: number;
  int2_6?: number;
  int2_7?: number;
  int2_8?: number;
  double1_1?: number;
  double1_2?: number;
  double1_3?: number;
  double1_4?: number;
  double1_5?: number;
  double1_6?: number;
  double1_7?: number;
  double1_8?: number;
  double2_1?: number;
  double2_2?: number;
  double2_3?: number;
  double2_4?: number;
  double2_5?: number;
  double2_6?: number;
  double2_7?: number;
  double2_8?: number;
  otp?: string;
  tipoRicezioneOTP?: string;
  otpTimestamp?: string;
  inizioLavorazione?: string;
  operatore?: string;
  origineRichiesta?: string;
  codiceAnpr?: string;
  lockStatus?: boolean;
  lockUser?: string;
  valoreBonusRiconosciuto?: number;
  valoreBonusRiconosciutoRedistribuito?: number;
  timestampRichiesta?: string;
  timestampConfermaPratica?: string;
  punteggioPraticaSportello?: number;
  punteggioPratica?: number;
  fasciaAppartenenza?: number;
  isScuolaObbligo?: boolean;
  statusRichiesta?: RichiestaPraticaStatusBE;
  statusGraduatoria?: string;
  aggiornamenti?: AggiornamentoPratica[];
  note?: NotaPratica[];
  created_at?: string;
  updated_at?: string;
  [key: string]: any;
}
